export default __webpack_public_path__ + "static/media/waste-water.d5128166.png";